import {
  HDMF_EMPLOYEE_SHARE_KEYS,
  HDMF_LOAN_FIELDS,
} from "../payrollReportConfig";
import {
  buildEmployeeAmountPipeline,
  buildEmployeeSummaryPipeline,
  buildNamedContributionSum,
  buildNamedDeductionSum,
  buildPayrollAmountLookups,
  ENTRY_AMOUNT_PERIOD_SUM,
  ENTRY_KEY,
} from "./shared";

const HDMF_EMPLOYEE_SHARE_SUM = buildNamedContributionSum(
  HDMF_EMPLOYEE_SHARE_KEYS,
);
const HDMF_LOAN_KEYS = HDMF_LOAN_FIELDS.map(({ key }) => key);

/**
 * HDMF loan reporting needs per-loan totals from the same array. Parsing
 * "name: amount" once per row keeps it to a single pass over deductions.
 */
const HDMF_LOAN_STAGES = [
  { $match: { deductions: { $regex: "^dueToPagIbig" } } },
  {
    $addFields: {
      hdmfLoanEntries: {
        $map: {
          input: { $ifNull: ["$deductions", []] },
          in: { k: ENTRY_KEY, v: ENTRY_AMOUNT_PERIOD_SUM },
        },
      },
    },
  },
];

function sumParsedHdmfLoans(keys) {
  return {
    $sum: {
      $map: {
        input: {
          $filter: {
            input: "$hdmfLoanEntries",
            cond: { $in: ["$$this.k", keys] },
          },
        },
        in: "$$this.v",
      },
    },
  };
}

export const HDMF_LOAN_SUMS = Object.fromEntries([
  ...HDMF_LOAN_KEYS.map((key) => [key, sumParsedHdmfLoans([key])]),
  ["totalHdmfLoan", sumParsedHdmfLoans(HDMF_LOAN_KEYS)],
]);

export const HDMF_EMPLOYEE_SHARE_LOOKUPS = buildPayrollAmountLookups(
  "hdmfEmployeeShare",
  "employeeContribution",
  HDMF_EMPLOYEE_SHARE_SUM,
);

/** Single total of HDMF loan deductions — used by HDMF payment summary. */
export const HDMF_LOAN_TOTAL_LOOKUPS = buildPayrollAmountLookups(
  "hdmfLoanTotal",
  "loans",
  buildNamedDeductionSum(HDMF_LOAN_KEYS),
);

export function getHdmfEmployeeShareByEmployeePipeline(employeeIds = []) {
  return buildEmployeeAmountPipeline(
    employeeIds,
    "employeeContribution",
    HDMF_EMPLOYEE_SHARE_SUM,
  );
}

export function getHdmfLoansByEmployeePipeline(employeeIds = []) {
  return buildEmployeeSummaryPipeline(
    employeeIds,
    HDMF_LOAN_SUMS,
    HDMF_LOAN_STAGES,
  );
}
